import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderHabaneroBig = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="130"
    height="28"
    viewBox="0 0 130 28"
    fill="none"
  >
    <path d="M125.301 13.394H124.551V11.1807H123.844V10.5156H126.05V11.1807H125.299L125.301 13.394Z" fill="white" />
    <path
      d="M129.922 13.394H129.186L129.24 11.1893H129.219L128.527 13.394H127.883L127.172 11.1893H127.147L127.211 13.394H126.475V10.5156H127.653L128.184 12.3249H128.213L128.713 10.5156H129.921L129.922 13.394Z"
      fill="white"
    />
    <path
      d="M38.2328 22.5487H35.0525V17.7396H30.9357V22.5487H27.752V10.3071H30.9357V14.9319H35.0566V10.3071H38.237L38.2328 22.5487Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.7265 22.5487L43.2952 20.438H47.5404L48.1625 22.5487H51.3954L47.7898 10.3071H42.975L39.4227 22.5487H42.7265ZM43.9706 18.0705L45.4266 12.7479L46.9192 18.0705H43.9706Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.5862 10.3071H59.037C60.1143 10.3192 60.9729 10.53 61.6128 10.9395C62.2527 11.349 62.5723 12.1841 62.5717 13.4449C62.5847 14.0716 62.4916 14.6958 62.2966 15.2894C62.1126 15.8098 61.5883 16.1435 60.7239 16.2905V16.3818C61.5294 16.4674 62.0714 16.7305 62.3499 17.171C62.6285 17.6115 62.7674 18.2356 62.7669 19.0431C62.7669 20.4141 62.5034 21.3409 61.9764 21.8233C61.4494 22.3058 60.4874 22.5476 59.0904 22.5487H52.5862V10.3071ZM57.7904 15.2076C57.837 15.2195 57.8849 15.2256 57.9329 15.2257H58.0572C58.3854 15.2217 58.7115 15.1692 59.0253 15.0697C59.291 14.9778 59.4242 14.6812 59.4247 14.1797C59.4247 13.7386 59.3508 13.4357 59.2029 13.2708C59.0551 13.106 58.7679 13.0236 58.3415 13.0236H55.7657V15.2076H57.7904ZM59.1145 19.7134C58.7125 19.8266 58.2957 19.8728 57.8796 19.8504H55.7657V17.4829H58.093C58.59 17.4817 58.9658 17.5337 59.2204 17.6388C59.475 17.7439 59.6023 18.0837 59.6023 18.658C59.6023 19.2571 59.4397 19.6089 59.1145 19.7134Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M66.4234 22.5487L66.9921 20.438H71.2381L71.8602 22.5487H75.0931L71.4866 10.3071H66.676L63.1229 22.5487H66.4234ZM67.6675 18.0705L69.1268 12.7479L70.6161 18.0705H67.6675Z"
      fill="white"
    />
    <path
      d="M87.7588 22.5487H82.3762L79.0407 13.1338H78.8981L79.0407 22.5487H75.9279V10.3071H81.2746L84.6143 19.6117H84.7385L84.6143 10.3071H87.7588V22.5487Z"
      fill="white"
    />
    <path
      d="M92.5018 15.2076H97.5467V17.4829H92.5018V19.8504H98.0053V22.5487H89.3214V10.3071H97.9019V13.0046H92.5018V15.2076Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M105.469 10.3071H99.5005L99.5022 22.5487H102.682V19.3188H105.044C105.565 19.3182 105.918 19.4618 106.101 19.7496C106.285 20.0373 106.377 20.4262 106.377 20.9161V22.5487H109.609V20.3285C109.61 19.583 109.435 19.0049 109.086 18.5943C108.736 18.1836 108.194 17.9539 107.461 17.905V17.7948C108.561 17.5495 109.209 17.1429 109.405 16.5748C109.601 16.0068 109.699 15.2633 109.699 14.3443C109.699 12.7045 109.373 11.6247 108.721 11.1049C108.069 10.5851 106.985 10.3192 105.469 10.3071ZM106.26 16.1061C106.135 16.3882 105.783 16.5228 105.202 16.5102H102.68V13.1338L105.042 13.1511C105.717 13.1505 106.12 13.2912 106.251 13.5732C106.381 13.8552 106.447 14.2961 106.447 14.8957C106.447 15.4206 106.384 15.8241 106.26 16.1061Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.958 15.0422C110.946 15.2868 110.94 15.5341 110.94 15.7857H110.942V17.426C110.942 17.8539 110.954 18.2821 110.978 18.7106C111.001 19.1398 111.073 19.5648 111.19 19.9771C111.475 21.0029 112.013 21.6881 112.807 22.0327C113.614 22.3785 114.474 22.5714 115.347 22.6022C115.548 22.6142 115.75 22.6228 115.952 22.6297C116.152 22.6355 116.347 22.6384 116.536 22.6384C119.201 22.6378 120.774 22.0505 121.253 20.8765C121.732 19.7025 121.972 17.9835 121.972 15.7193C121.972 13.5058 121.564 12.0411 120.747 11.3255C119.929 10.6098 118.496 10.252 116.447 10.252H116.092C115.003 10.2665 113.926 10.4839 112.912 10.8939C111.927 11.2982 111.323 12.1853 111.1 13.5552C111.065 13.7998 111.035 14.048 111.011 14.2987C110.988 14.5494 110.969 14.7975 110.958 15.0422ZM114.192 17.19V16.4551L114.197 16.4585V16.4034C114.222 14.8635 114.349 13.9213 114.579 13.5767C114.809 13.2321 115.541 13.0598 116.773 13.0598C117.628 13.0586 118.167 13.2482 118.389 13.6284C118.612 14.0086 118.723 14.6082 118.723 15.4273V16.3086C118.711 16.4672 118.705 16.6205 118.705 16.767V17.2081C118.706 18.2482 118.561 18.9487 118.27 19.3094C117.979 19.6701 117.289 19.8504 116.2 19.8504C115.217 19.8504 114.637 19.6241 114.459 19.1715C114.281 18.7189 114.192 18.0584 114.192 17.19Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0764 3.69917C10.2343 3.70032 10.3861 3.63626 10.498 3.52123C10.61 3.40621 10.6728 3.24974 10.6726 3.08661V1.31701C10.6726 0.979186 10.4075 0.705322 10.0806 0.705322C9.75359 0.705322 9.48853 0.979186 9.48853 1.31701V3.08661C9.48851 3.42291 9.75092 3.69633 10.0764 3.69917Z"
      fill="url(#habanero-big-rule-1)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.7074 5.32399C7.86457 5.32399 8.01528 5.25942 8.12634 5.14452C8.23739 5.02962 8.29967 4.87381 8.29945 4.71143V2.94183C8.29945 2.604 8.03438 2.33014 7.7074 2.33014C7.38042 2.33014 7.11536 2.604 7.11536 2.94183V4.71143C7.11536 5.0494 7.38029 5.32351 7.7074 5.32399Z"
      fill="url(#habanero-big-rule-2)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70829 1.23085C8.03397 1.23085 8.2985 0.959081 8.30034 0.622599V0.635522C8.30848 0.411355 8.19737 0.20052 8.01071 0.085937C7.82405 -0.0286457 7.5917 -0.0286457 7.40504 0.085937C7.21838 0.20052 7.10727 0.411355 7.11541 0.635522V0.622599C7.11725 0.959417 7.38228 1.23133 7.70829 1.23085Z"
      fill="url(#habanero-big-rule-3)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4463 5.79182C12.6034 5.79182 12.754 5.72723 12.8649 5.6123C12.9758 5.49738 13.0379 5.34157 13.0375 5.17927V5.19305C13.0375 4.85522 12.7724 4.58136 12.4454 4.58136C12.1185 4.58136 11.8534 4.85522 11.8534 5.19305V5.18013C11.8534 5.34251 11.9159 5.49823 12.0271 5.61297C12.1383 5.72771 12.2891 5.79205 12.4463 5.79182Z"
      fill="url(#habanero-big-rule-4)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.1835 10.3295C17.0264 10.3295 16.8756 10.3941 16.7646 10.509C16.6535 10.6239 16.5912 10.7797 16.5915 10.9421V11.2497C16.5679 11.577 16.2986 11.827 15.981 11.8164C15.6634 11.8057 15.4104 11.5383 15.4074 11.21V9.68337C15.4155 9.45921 15.3044 9.24837 15.1177 9.13379C14.9311 9.01921 14.6987 9.01921 14.5121 9.13379C14.3254 9.24837 14.2143 9.45921 14.2225 9.68337V9.71697C14.2306 9.94083 14.1196 10.1514 13.9332 10.2658C13.7468 10.3802 13.5148 10.3802 13.3284 10.2658C13.142 10.1514 13.0311 9.94083 13.0392 9.71697V7.1582C13.0392 6.82085 12.7745 6.54737 12.448 6.54737C12.1215 6.54737 11.8568 6.82085 11.8568 7.1582V8.13347C11.8476 8.46842 11.5864 8.73746 11.2622 8.74602C11.1051 8.74625 10.9544 8.68188 10.8433 8.56711C10.7323 8.45235 10.67 8.29663 10.6702 8.13433V5.3774C10.6783 5.15324 10.5672 4.9424 10.3805 4.82782C10.1939 4.71324 9.96153 4.71324 9.77487 4.82782C9.58821 4.9424 9.47711 5.15324 9.48525 5.3774V7.77334C9.48525 8.11117 9.22018 8.38504 8.8932 8.38504C8.56622 8.38504 8.30115 8.11117 8.30115 7.77334V6.9118C8.3093 6.68764 8.19819 6.4768 8.01153 6.36222C7.82487 6.24764 7.59252 6.24764 7.40586 6.36222C7.2192 6.4768 7.10809 6.68764 7.11623 6.9118V8.7555C7.11623 9.09333 6.85116 9.36719 6.52418 9.36719C6.1972 9.36719 5.93214 9.09333 5.93214 8.7555V6.19759C5.93214 5.85976 5.66707 5.5859 5.34009 5.5859C5.01311 5.5859 4.74804 5.85976 4.74804 6.19759V10.1116C4.74804 10.4494 4.48298 10.7233 4.156 10.7233C3.82902 10.7233 3.56395 10.4494 3.56395 10.1116V9.07771C3.57209 8.85354 3.46098 8.64271 3.27432 8.52813C3.08766 8.41354 2.85531 8.41354 2.66865 8.52813C2.48199 8.64271 2.37088 8.85354 2.37902 9.07771V11.9596C2.38717 12.1837 2.27606 12.3946 2.0894 12.5091C1.90274 12.6237 1.67039 12.6237 1.48373 12.5091C1.29707 12.3946 1.18596 12.1837 1.1941 11.9596V11.0119C1.1941 10.674 0.929031 10.4002 0.602053 10.4002C0.275074 10.4002 0.0100064 10.674 0.0100064 11.0119L0 11.9596V22.5591L8.88653 27.8601L17.7731 22.5591V15.852C17.7731 15.8417 17.7731 15.8322 17.7731 15.8218V10.9421C17.7735 10.6049 17.5098 10.331 17.1835 10.3295ZM13.0725 20.7274H10.2808V18.5314H7.4898V20.7274H4.69885V13.8524H7.4898V16.1639H10.2808V13.8524H13.0725V20.7274Z"
      fill="url(#habanero-big-rule-5)"
    />
    <defs>
      <linearGradient
        id="habanero-big-rule-1"
        x1="0.267614"
        y1="24.3996"
        x2="17.8264"
        y2="24.3996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA142E" />
        <stop offset="1" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient
        id="habanero-big-rule-2"
        x1="0.905542"
        y1="25.8293"
        x2="18.31"
        y2="25.8293"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA142E" />
        <stop offset="1" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient
        id="habanero-big-rule-3"
        x1="0.511175"
        y1="9.69551"
        x2="17.9874"
        y2="9.69551"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA142E" />
        <stop offset="1" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient
        id="habanero-big-rule-4"
        x1="0.418564"
        y1="14.0387"
        x2="17.7363"
        y2="14.0387"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA142E" />
        <stop offset="1" stopColor="#FF870D" />
      </linearGradient>
      <linearGradient
        id="habanero-big-rule-5"
        x1="-0.000833868"
        y1="27.8751"
        x2="17.7756"
        y2="27.8751"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FA142E" />
        <stop offset="1" stopColor="#FF870D" />
      </linearGradient>
    </defs>
  </svg>
);

IconProviderHabaneroBig.propTypes = {
  className: PropTypes.string,
};
IconProviderHabaneroBig.defaultProps = {
  className: null,
};
